import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/chat/empty-img-default.svg'
import _imports_1 from '@/assets/general/returnLeft.svg'


const _withScopeId = n => (_pushScopeId("data-v-477b5656"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contacts" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "leftTabs" }
const _hoisted_4 = ["infinite-scroll-disabled"]
const _hoisted_5 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_6 = {
  class: "skeletonMail",
  style: {"margin":"20px 0"}
}
const _hoisted_7 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_8 = ["element-loading-text"]
const _hoisted_9 = {
  key: 0,
  class: "noMore"
}
const _hoisted_10 = {
  key: 2,
  class: "empty"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "empty-text" }
const _hoisted_13 = { class: "rightTabs" }
const _hoisted_14 = { class: "mailContent" }
const _hoisted_15 = {
  key: 1,
  class: "content"
}
const _hoisted_16 = ["infinite-scroll-disabled"]
const _hoisted_17 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_18 = {
  class: "skeletonMail",
  style: {"margin":"20px 0"}
}
const _hoisted_19 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_20 = ["element-loading-text"]
const _hoisted_21 = {
  key: 0,
  class: "noMore"
}
const _hoisted_22 = {
  key: 2,
  class: "empty"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_24 = { class: "empty-text" }
const _hoisted_25 = {
  key: 1,
  class: "rightTabs"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "returnStyle"
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "mailContent" }

import { ref, watch, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getContactsListApi, syncContactsListApi } from "@/api/chat/index";
import mailListItem from "./component/mailListItem.vue";
import contactItem from "@/views/generalApp/component/contactItem.vue";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import { ElMessage } from "element-plus";
import { gaEvent } from "@/utils/format";
import { useRouter } from "vue-router";
import { jsonData, jsonData1 } from '@/mock/contacts.js'


type mailType = {
  label: string;
  children: Array<mailType>;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'contacts',
  setup(__props) {

const store = useStore();
let router = useRouter();
const { t } = useI18n();
const deviceId = computed(() => store.state.currentDeviceInfo.id);
const currentContact = computed(() => store.state.clickMailItemDetail)
const messageToastType = computed(() => store.state.messageToastType);
const skeletonLoading = ref(true)

const isVibe = computed(() => !store.state.isVibe);
const isShowMore750 = computed(() => store.state.isShowMore750);
const showRight = ref(false)
const deviceType = computed(() => {
  return store.state.deviceType
})
const demoData = (type?: string) => {
  lastUpdateTime.value = jsonData.data.update_time
  showUpdateTime.value = true
  mailList.value = jsonData.data.contacts
  if (type == 'add_time') {
    mailList.value = jsonData1.data.contacts
  }
  console.log("mailList.value:", mailList.value);
  setTimeout(() => {
    const bottomDomList = document.querySelectorAll('.bottom') as any
    bottomDomList[0].classList.add('active')
  })
  if (sortRule.value == 'add_time') {
    store.commit('setClickMailItemDetail', mailList.value[0])
  } else {
    store.commit('setClickMailItemDetail', mailList.value[0].children[0])
  }
  mailGlobalLoading.value = false;
  skeletonLoading.value = false;
}
onMounted(async () => {
  mailPageNum.value = 1
  mailList.value = []
  cumulativeMailList = []
  noMoreMail.value = false
  store.commit('setClickMailItemDetail', [])
  console.log('setClickMailItemDetail', store.state.clickMailItemDetail);

  await getContactList()
  gaEvent("Contact_PV", {
    event_category: "Contacts",
    event_label: mailList.value.length > 0 ? "Data" : "NoData",
  });
  gaEvent("Contact_Sort", {
    event_category: "Contacts",
    event_label: "Name",
  });
})
onUnmounted(() => {
  clearInterval(closeFiveM);
})
const sortRule = ref('')

const sortRules = ref([
  {
    id: 1,
    label: 'Sort by name',
    value: 'add_name',
  },
  {
    id: 2,
    label: 'Sort by time',
    value: 'add_time',
  }
])

let showLabel = ref(true)
const showUpdateTime = ref(false)
let lastUpdateTime = ref(0)

// 五分钟定时更新
let closeFiveM: any
if (!deviceType.value) {
  closeFiveM = setInterval(() => {
    mailPageNum.value = 1
    mailList.value = []
    cumulativeMailList = []
    noMoreMail.value = false
    getContactList()
  }, 1000 * 60 * 5);
}


const changeSort = (e: any) => {
  mailPageNum.value = 1
  mailList.value = []
  cumulativeMailList = []
  noMoreMail.value = false
  nameSortLabelLength = 0
  mailGlobalLoading.value = true;
  skeletonLoading.value = true;

  console.log("切换");

  if (e == 'add_time') {
    gaEvent("Contact_Sort", {
      event_category: "Contacts",
      event_label: "Date",
    });
    showLabel.value = false
    if (isVibe.value) {
      demoData('add_time')
    } else {
      getContactList()
    }
  } else {
    gaEvent("Contact_Sort", {
      event_category: "Contacts",
      event_label: "Name",
    });
    showLabel.value = true
    if (isVibe.value) {
      demoData()
    } else {
      getContactList()
    }
  }
  if (!isVibe.value || !deviceType) {
    clearInterval(closeFiveM);
    setNewInterval()
  }
}


watch(deviceId, async () => {
  mailPageNum.value = 1
  mailList.value = []
  cumulativeMailList = []
  noMoreMail.value = false
  mailGlobalLoading.value = true;
  skeletonLoading.value = true;
  store.commit('setClickMailItemDetail', [])

  await getContactList()
  gaEvent("Contact_PV", {
    event_category: "Contacts",
    event_label: mailList.value.length > 0 ? "Data" : "NoData",
  });
  if (!isVibe.value || !deviceType) {
    clearInterval(closeFiveM);
    if (!deviceType) setNewInterval()
  }
})

watch(isShowMore750, (newV, oldV) => {
  if (!newV) {
    showRight.value = false
  } else {
    showRight.value = true
  }
})

const mailList = ref<mailType[]>([]);
let nameSortLabelLength = 0
let cumulativeMailList: mailType[] = [];
let mailPageNum = ref(1); // 页码
let mailPageSize = ref(15); // 一页多少条数据
let noMoreMail = ref(false); // 是否展示没有更多数据文案
let mailGlobalLoading = ref(true);
const mailLoading = ref(false);
const loadMoreMailList = () => {
  console.log('chudi');
  if (isVibe.value) return
  mailPageNum.value = mailPageNum.value + 1
  mailLoading.value = true;
  setTimeout(async () => {
    const res: any = await getContactList(true, false);
    console.log('rrrrr', res, mailList.value.length);
    mailLoading.value = false;
    console.log('mailList.value', mailList.value);
    if (sortRule.value == 'add_time') {
      if (mailList.value.length >= res.total) {
        // 如果当前列表总长度不是 pageSize的倍数，则显示没有更多数据文案
        noMoreMail.value = true;
      } else {
        if (nameSortLabelLength >= res.total) {
          // 如果当前列表总长度不是 pageSize的倍数，则显示没有更多数据文案
          noMoreMail.value = true;
        }
      }
    }

  }, 100);
};
// 正在加载数据 或者 已经没有更多数据时 禁止滚动
const disabledMailScroll = computed(
  () => mailLoading.value || noMoreMail.value
);
const appId = computed(() => store.state.currentDeviceInfo.apple_id);
const getContactList = async (isFromScroll: boolean = false, isFromSync: Boolean = false) => {
  try {
    let onePageMailList: mailType[] = [];
    if (isVibe.value) {
      demoData()
      return
    }
    const params = {
      device_id: deviceId.value,
      app: 'native',
      page: mailPageNum.value,
      sort_field: sortRule.value,
    } as {
      device_id?: any;
      app: string;
      page: number;
      sort_field: string;
      apple_id?: string; // 添加了可选的 apple_id 属性
    }
    console.log("deviceType:", deviceType.value);

    if (deviceType.value == 1) {
      params.apple_id = appId.value;
      delete params.device_id; // 删除 device_id 属性
    }
    const res = await getContactsListApi(params);
    console.log('rerrrr', res, res.data.code, sortRule.value);
    if (res.data.code == 200) {
      if (!isFromSync) {
        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      } else {
        gaEvent("Contact_Sync", {
          event_category: "Contacts",
          event_label: "Success",
        });
        if ((lastUpdateTime.value == res.data.data.update_time)) {
          ElMessage({
            message: t("famikeep200['Synchronization successful, no new data']"),
            type: "success",
          });
        } else {
          ElMessage({
            message: t("chat.syncSuccessed"),
            type: "success",
          });
        }

        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      }

      if (res.data.data.total === 0) {
        mailList.value = []
        return [];
      }
      onePageMailList = res.data.data.contacts;

      console.log('sortRule.value', sortRule.value);

      // 按照时间排序
      if (sortRule.value == 'add_time') {
        console.log('mailList.value.length', mailList.value.length);
        if (mailList.value.length == res.data.data.total) {
          cumulativeMailList = onePageMailList;
          // 当前列表数据与数据库总条数相等，这说明数据已经全部加载完成
          noMoreMail.value = true;
        } else {
          cumulativeMailList = cumulativeMailList.concat(onePageMailList);
        }
        mailList.value = cumulativeMailList;
      } else {
        res.data.data.contacts.forEach((item: any) => {
          if (item.children.length) {
            nameSortLabelLength += item.children.length
          }
        })

        if (nameSortLabelLength == res.data.data.total) {
          cumulativeMailList = onePageMailList;
          // 当前列表数据与数据库总条数相等，这说明数据已经全部加载完成
          noMoreMail.value = true;
        } else {
          cumulativeMailList = onePageMailList;
        }
        // 对于请求到的重复label进行合并
        const resultArr = mailList.value.concat(cumulativeMailList)
        mailList.value = mergeChildrenByLabel(resultArr);
        console.log('mailList', mailList.value);

      }
      // mailList.value = mailList.value.concat(cumulativeMailList);



      // ???????????????????????????
      if (res.data.data.contacts.length > 0) {
        console.log('isFromScroll', isFromScroll, store.state.clickMailItemDetail);
        if (isFromScroll) {
          console.log('iiiif');
          if (sortRule.value == 'add_time') {
            // store.commit('setClickMailItemDetail', mailList.value[0]) 
          } else {
            // store.commit('setClickMailItemDetail', mailList.value[0].children[0]) 
          }
        } else {
          // 自主控制选中第一个
          setTimeout(() => {
            const bottomDomList = document.querySelectorAll('.bottom') as any
            bottomDomList[0].classList.add('active')
          })
          if (sortRule.value == 'add_time') {
            store.commit('setClickMailItemDetail', res.data.data.contacts[0])
          } else {
            store.commit('setClickMailItemDetail', res.data.data.contacts[0].children[0])
          }
        }
      }
      return new Promise((resolve, reject) => {
        // resolve(onePageContactList)
        resolve(res.data.data);
      });
    }

    console.log('mailList', mailList.value);

  } catch (err: any) {
    if (isFromSync) {
      gaEvent("Contact_Sync", {
        event_category: "Contacts",
        event_label: "Fail",
      });
      ElMessage({
        message: t("chat.syncFailed"),
        type: "error",
      });
    }

    // mailGlobalLoading.value = false;
  } finally {
    mailGlobalLoading.value = false;
    setTimeout(() => {
      store.commit("setSyncLoading", false);
      skeletonLoading.value = false;

    }, 1000)
  }
}

const mergeChildrenByLabel = (arr: any) => {
  // 创建一个空对象来存储每个 label 对应的 children 数组
  const labelToChildrenMap = {} as any;

  // 遍历原始数组
  for (const obj of arr) {
    const label = obj.label;
    const children = obj.children;

    // 如果该 label 已经存在于映射中，将 children 合并到已有的数组中
    if (labelToChildrenMap[label]) {
      labelToChildrenMap[label].push(...children);
    } else {
      // 如果该 label 还不存在，创建一个新数组
      labelToChildrenMap[label] = [...children];
    }
  }

  // 创建一个新数组来存储合并后的结果
  const mergedArray = [];

  // 将映射中的数据转化为对象数组
  for (const label of Object.keys(labelToChildrenMap)) {
    mergedArray.push({ label, children: labelToChildrenMap[label] });
  }

  return mergedArray;
}

const syncContactsList = async () => {


}
const updateInfo = async () => {
  if (isVibe.value) {
    store.commit("setSyncLoading", false);
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  mailGlobalLoading.value = true
  skeletonLoading.value = true;

  mailPageNum.value = 1
  mailList.value = []
  cumulativeMailList = []
  noMoreMail.value = false
  // await syncContactsList()
  if (deviceType.value) {
    let params = {
      apple_id: appId.value
    }
    try {
      let res = await syncContactsListApi(params);
      console.log("res:", res);
      if (res.data.sync_status == 'syncing') {
        ElMessage({
          message: t("chat.syncSuccessed"),
          type: "success",
        });
        return
      } else if (res.status != 200) {
        store.commit("setSyncLoading", false);
        ElMessage({
          message: t("chat.syncFailed"),
          type: "error",
        });
      }
      await getContactList()
      clearInterval(closeFiveM);
    } catch (err: any) {
      console.log("同步报错了老弟");
    }
  } else {
    await getContactList(false, true)
    clearInterval(closeFiveM);
    if (!deviceType.value) setNewInterval()
  }
}

// 设置新的定时器
const setNewInterval = () => {
  closeFiveM = setInterval(() => {
    mailPageNum.value = 1
    mailList.value = []
    cumulativeMailList = []
    noMoreMail.value = false
    getContactList()
  }, 1000 * 60 * 5);
}

const clickMailItem = () => {
  showRight.value = true
}

const returnLeft = () => {
  showRight.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep200.Contacts'),
      showUpdateTime: showUpdateTime.value,
      headerSyncDate: _unref(lastUpdateTime),
      headerSelectData: [],
      onUpdateInfo: updateInfo,
      showRightBox: false
    }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate"]),
    (isShowMore750.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!deviceType.value)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: sortRule.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sortRule).value = $event)),
                  placeholder: _ctx.$t('famikeep200.Sort by name'),
                  size: "large",
                  onChange: changeSort
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortRules.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: _ctx.$t(`famikeep200.${item.label}`),
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              "infinite-scroll-immediate": false,
              "infinite-scroll-disabled": disabledMailScroll.value,
              class: "scrollStyle",
              "infinite-scroll-distance": "1"
            }, [
              (_unref(mailGlobalLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_el_skeleton, {
                      style: {"--el-skeleton-circle-size":"40px","width":"100%","padding-left":"10px"},
                      loading: _unref(mailGlobalLoading),
                      animated: true,
                      count: 10
                    }, {
                      template: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle",
                            style: {"margin-right":"12px"}
                          }),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"55%"}
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : (!_unref(mailGlobalLoading) && mailList.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mailList.value, (item, index) => {
                        return (_openBlock(), _createBlock(mailListItem, {
                          key: index,
                          item: item,
                          showLabel: _unref(showLabel),
                          sortByTime: sortRule.value == 'add_time',
                          isGeneral: true
                        }, null, 8, ["item", "showLabel", "sortByTime"]))
                      }), 128)),
                      _withDirectives(_createElementVNode("div", {
                        "element-loading-text": _ctx.$t('chat.loadingText'),
                        style: _normalizeStyle({ 'margin-top': mailLoading.value ? '40px' : '10px' })
                      }, null, 12, _hoisted_8), [
                        [_directive_loading, mailLoading.value]
                      ]),
                      (_unref(noMoreMail))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("chat.noAddressText")), 1)
                    ]))
            ], 8, _hoisted_4)), [
              [_directive_infinite_scroll, loadMoreMailList]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(contactItem, {
                currentContact: currentContact.value,
                skeletonLoading: skeletonLoading.value
              }, null, 8, ["currentContact", "skeletonLoading"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (!showRight.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["leftTabs", isShowMore750.value ? '' : 'mobileLefttabs'])
              }, [
                (!deviceType.value)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: sortRule.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortRule).value = $event)),
                      placeholder: _ctx.$t('famikeep200.Sort by name'),
                      size: "large",
                      onChange: changeSort
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortRules.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: _ctx.$t(`famikeep200.${item.label}`),
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"]))
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  "infinite-scroll-immediate": false,
                  "infinite-scroll-disabled": disabledMailScroll.value,
                  class: _normalizeClass(["scrollStyle", isShowMore750.value ? '' : 'mobileScrollStyle']),
                  "infinite-scroll-distance": "1"
                }, [
                  (_unref(mailGlobalLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_el_skeleton, {
                          style: {"--el-skeleton-circle-size":"40px","width":"100%","padding-left":"10px"},
                          loading: _unref(mailGlobalLoading),
                          animated: true,
                          count: 10
                        }, {
                          template: _withCtx(() => [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_el_skeleton_item, {
                                variant: "circle",
                                style: {"margin-right":"12px"}
                              }),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"55%"}
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]))
                    : (!_unref(mailGlobalLoading) && mailList.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mailList.value, (item, index) => {
                            return (_openBlock(), _createBlock(mailListItem, {
                              key: index,
                              item: item,
                              showLabel: _unref(showLabel),
                              sortByTime: sortRule.value == 'add_time',
                              isGeneral: true,
                              onClickMailItem: clickMailItem
                            }, null, 8, ["item", "showLabel", "sortByTime"]))
                          }), 128)),
                          _withDirectives(_createElementVNode("div", {
                            "element-loading-text": _ctx.$t('chat.loadingText'),
                            style: _normalizeStyle({ 'margin-top': mailLoading.value ? '40px' : '10px' })
                          }, null, 12, _hoisted_20), [
                            [_directive_loading, mailLoading.value]
                          ]),
                          (_unref(noMoreMail))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("chat.noAddressText")), 1)
                        ]))
                ], 10, _hoisted_16)), [
                  [_directive_infinite_scroll, loadMoreMailList]
                ])
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", {
                  class: "returnLeft",
                  onClick: returnLeft
                }, _hoisted_27),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(contactItem, {
                    currentContact: currentContact.value,
                    skeletonLoading: skeletonLoading.value
                  }, null, 8, ["currentContact", "skeletonLoading"])
                ])
              ]))
        ]))
  ]))
}
}

})